module.exports = __webpack_public_path__ + "img/mobileculture2.aed4f721.png";